<template>
	<div class="container-wrap rtr_mypage-certification">
		<div class="container-box">
			<!-- <div class="level_content">
				<span class="level_bar_back"></span>
				<span
					class="level_bar_red"
					:style="{
						width: `${
							100 *
							(($store.state.auth.member_info.security_level - 1) /
								(maxLevel - 1))
						}%`,
					}"
				></span>
				<ul class="level_box">
					<li
						v-for="idx in maxLevel"
						:key="idx"
						:class="[
							'level',
							{
								selected: $store.state.auth.member_info.security_level >= idx,
								exact_selected:
									$store.state.auth.member_info.security_level === idx,
							},
						]"
					>
						<p class="level_color">Level {{ idx }}</p>
					</li>
				</ul>
			</div> -->

			<div class="card">
				<h3 class="title d_flex justify_between">
					<div>
						<img
							:src="iconManagingAuthenticationTitle"
							alt=""
							style="width: 18px; height: 18px"
						/>
						{{ $t('merchant.title6') }}
					</div>
					<div class="d_flex align_items_center">
						<img
							:src="iconLevel"
							alt=""
							:style="
								isMobile
									? { width: '14px', height: '14px' }
									: { width: '24px', height: '24px' }
							"
						/>
						<p class="level_color mb_0 ml_5">
							Level {{ $store.state.auth.member_info.security_level }}
						</p>
					</div>
				</h3>
			</div>
			<div class="card pt_40">
				<!-- <SecurityInfo></SecurityInfo> -->
				<div class="">
					<ul :class="['tab_area', 'justify_center', 'mb_30', 'mt_0']">
						<li
							v-for="(levelInfo, idx) in levels"
							:key="levelInfo.type"
							:class="{ selected: idx === selectedLevelIdx }"
							@click.prevent="handleSelectLevel(idx)"
						>
							<div
								:class="[
									`level_${idx + 1}`,
									'box',
									{
										level_on: selectedLevelIdx >= idx,
										on: idx === selectedLevelIdx,
									},
								]"
							>
								<!-- <p class="text_g">{{ $t('merchant.security.level1') }}</p> -->
								<a class="">{{ $t(levelInfo.lang_code) }}</a>
								<!-- <div class="display_status" v-if="securityLevel === 0">
									{{ $t('merchant.security.authStatus.no') }}
								</div>
								<div class="display_status completed" v-if="securityLevel >= 1">
									{{ $t('merchant.security.authStatus.ok') }}
								</div> -->
							</div>
						</li>
					</ul>
					<div class="level_content_box">
						<component :is="levels[selectedLevelIdx].type"></component>
					</div>
				</div>
				<div v-if="0" class="limit gray_back">
					<p class="mb_20">{{ $t('merchant.security.title3') }}</p>
					<ul>
						<li>
							<span>{{ $t('merchant.security.text1') }}</span>
							<span>{{ $t('merchant.security.text2') }}</span>
						</li>
						<li>
							<span>{{ $t('merchant.security.text3') }}</span>
							<span>{{ $t('merchant.security.text4') }}</span>
						</li>
						<li>
							<span>{{ $t('merchant.security.text5') }}</span>
							<span>{{ $t('merchant.security.text6') }}</span>
						</li>
						<li>
							<span>{{ $t('merchant.security.text7') }}</span>
							<span>{{ $t('merchant.security.text8') }}</span>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// import SecurityInfo from '@/components/Mypage/SecurityInfo';
import Email from '@/components/Mypage/Certification/Email';
import Kyc from '@/components/Mypage/Certification/Kyc';
import Otp from '@/components/Mypage/Certification/Otp';
import Security from '@/components/Mypage/Certification/Security';
import iconManagingAuthenticationTitle from '@/assets/images/v2/icon/icon-managing-authentication-title.svg';
import iconLevel from '@/assets/images/v2/icon/icon-level.svg';

export default {
	name: 'Certification',
	components: {
		Security,
		// SecurityInfo,
		Email,
		Kyc,
		Otp,
	},
	data() {
		return {
			maxLevel: 3,
			selectedLevelIdx: 0,
			mobile: window.innerWidth <= 768,
			iconManagingAuthenticationTitle,
			iconLevel,
			levels: [
				{
					type: 'email',
					lang_code: 'merchant.security.email',
					progress: 0,
				},
				{
					type: 'kyc',
					lang_code: 'merchant.security.kyc',
					progress: 33,
				},
				{
					type: 'otp',
					lang_code: 'merchant.security.otp',
					progress: 65,
				},
				/* {
					type: 'security',
					lang_code: 'merchant.security.address',
					progress: 100,
				}, */
			],
		};
	},
	computed: {
		isMobile() {
			return this.mobile;
		},
	},
	mounted() {
		this.checkMobile();
		window.addEventListener('resize', this.checkMobile);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.checkMobile);
	},
	methods: {
		checkMobile() {
			this.mobile = window.innerWidth <= 768;
		},
		handleSelectLevel(idx) {
			this.selectedLevelIdx = idx;
		},
	},
};
</script>

<style scoped></style>
